import { FunctionComponent, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useCurrentSitePage } from 'core-components/sitebuilder/layout/hooks/useCurrentSitePage'
import { AnalyticContext } from 'src/core/analytics/context/AnalyticContext'
import GoogleAnalyticsService from 'src/core/analytics/GoogleAnalyticsService'
import { useWidgetAnalytics } from 'src/core/analytics/hooks/useWidgetAnalytics'

export const withTracker = (WrappedComponent: FunctionComponent<any>) => {
  return function Component(props: object) {
    const location = useLocation()
    const currentSitePage = useCurrentSitePage()
    const widgetAnalytics = useWidgetAnalytics()

    useEffect(() => {
      const { name, id } = currentSitePage
      if (id && location.pathname.startsWith(`/page/${id}`)) {
        GoogleAnalyticsService.trackPage(location.pathname, name)
      }
    }, [currentSitePage, currentSitePage.id, currentSitePage.name, location.pathname])

    return (
      <AnalyticContext.Provider value={widgetAnalytics}>
        <WrappedComponent {...props} />
      </AnalyticContext.Provider>
    )
  }
}
